module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticStyle: {
      "margin-left": "10px",
      "padding": "0px",
      "margin-right": "0px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-list', [_vm._l((_vm.handleidingen), function(item) {
    return [_c('v-list-tile', {
      staticStyle: {
        "margin": "0px",
        "padding": "0px",
        "border-style": "solid",
        "border-width": "1px"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.clickFile(item)
        }
      }
    }, [_c('v-list-tile-content', [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])], 1)]
  })], 2), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e03e7a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/handleidingen.vue
// module id = 45
// module chunks = 3